import {config} from '../constants/Constants';
import AxiosServices from './axios-service';
import {endpoints} from './api-end-points';

export class LoginServices {  
  

  headers(){
    let obj = {
      'Authorization': 'Basic '+btoa(config.url.username+':'+config.url.password),
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }
    return obj;
  }

  ///---Get token if user information is valid--///

  login(body){    
    const res = AxiosServices.post(endpoints.auth.login, body, {headers : this.headers()});    
    return res;
  }

  ///---Reset Password by receiving email--///

  forgetPass(body){    
    const res = AxiosServices.post(endpoints.auth.forgetPassword, body, {headers : this.headers()});    
    return res;
  }

}
const loginServices = new LoginServices();
export default loginServices;
